/** @jsx jsx */

import React from 'react';
import { css, jsx } from '@emotion/core';

import { AsyncIndicator, Delay, Text } from '@zapier/common-components';

const messageCss = css`
  margin-top: 10px;
`;

export const ChangePlanIndicator = () => (
  <React.Fragment>
    <AsyncIndicator />
    <Delay delay={2000}>
      <div css={messageCss}>
        <Text type="body">
          A few seconds more, we're cooking your awesome new plan!
        </Text>
      </div>
    </Delay>
  </React.Fragment>
);
